// @vendors
const React = require('react');
const PropTypes = require('prop-types');


require('./RiskIndicator.scss');

const RiskNumbers = ({ riskValue }) => {
    const content = [1, 2, 3, 4, 5, 6, 7]
        .filter( pos => pos >= 1 & pos <= 7)
        .map( i =>
            riskValue !== i ?
                <span className="risk-indicator-risk-numbers__number" key={i}>{i}</span>
                : <span className="risk-indicator-risk-numbers__number--selected" key={i}>{i}</span>
        );

    return (
        !!content ? <div className="risk-indicator-risk-numbers__block"> {content} </div>: null
    );
}

RiskNumbers.propTypes = {
    riskValue: PropTypes.number,
}

RiskNumbers.defaultProps = {
    riskValue: 0,
}

module.exports = RiskNumbers;
